import apiClient from "services/apiClient";

async function editMarkerGroup(id: any, data: any) {
  const url = `/admin/marker-groups/${id}`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editMarkerGroup;
